import { render, staticRenderFns } from "./RoleDataruleModal.vue?vue&type=template&id=435b66de&scoped=true&"
import script from "./RoleDataruleModal.vue?vue&type=script&lang=js&"
export * from "./RoleDataruleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b66de",
  null
  
)

export default component.exports